var _rect, _rect2, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHourGlass = function SvgHourGlass(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 23.21,
    height: 23.21,
    x: 0.395,
    y: 0.395,
    fill: "#fff",
    rx: 11.605
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 23.21,
    height: 23.21,
    x: 0.395,
    y: 0.395,
    stroke: "#DBDBDB",
    strokeWidth: 0.79,
    rx: 11.605
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C29B40",
    d: "M12 24c6.627 0 12-5.372 12-12 0-6.627-5.373-12-12-12S0 5.373 0 12c0 6.628 5.373 12 12 12",
    opacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#C29B40",
    d: "M16.518 7.596v-.198A1.4 1.4 0 0 0 15.12 6H8.874a1.4 1.4 0 0 0-1.398 1.398v.198a3.28 3.28 0 0 0 1.098 2.4l1.626 1.482a.673.673 0 0 1 0 1.002l-1.626 1.464a3.28 3.28 0 0 0-1.098 2.4v.27A1.4 1.4 0 0 0 8.88 18h6.246a1.4 1.4 0 0 0 1.398-1.428v-.21a3.28 3.28 0 0 0-1.098-2.4L13.8 12.48a.673.673 0 0 1 0-1.002l1.62-1.464a3.28 3.28 0 0 0 1.098-2.418",
    opacity: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#F7F3EA",
    d: "m9.9 15.81 1.422-1.47a.977.977 0 0 1 1.422 0l1.422 1.47a.281.281 0 0 1-.198.48h-3.876a.283.283 0 0 1-.192-.48"
  })));
};
export default SvgHourGlass;